export const GET_EXPENSE_STATUS = 'GET_EXPENSE_STATUS';
export const FLAG_GETTING_EXPENSE_STATUS = 'FLAG_GETTING_EXPENSE_STATUS';
export const CLEAR_EXPENSE_STATUS = 'CLEAR_EXPENSE_STATUS';
export const GET_EXPENSE_STATUS_REMARK = 'GET_EXPENSE_STATUS_REMARK';
export const FLAG_EXPENSE_STATUS_REMARK_ACTIVITY =
  'FLAG_EXPENSE_STATUS_REMARK_ACTIVITY';
export const CLEAR_EXPENSE_STATUS_REMARK = 'CLEAR_EXPENSE_STATUS_REMARK';
export const GET_EXPENSE_REJECTED = 'GET_EXPENSE_REJECTED';
export const CLEAR_EXPENSE_REJECTED = 'CLEAR_EXPENSE_REJECTED';
